import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { JobPlaceModel, UpdateDefaultRequest } from '../models/jobPlace.model';

@Injectable({ providedIn: 'root' })
export class AssignmentsService {
  private readonly http = inject(HttpClient);
  readonly defaultJobPlaceResponse = signal<{ data: JobPlaceModel[] } | null>(null);
  updateDefaultJobPlace(customerId: number, payload: UpdateDefaultRequest) {
    this.http.post<{ data: JobPlaceModel[] }>(
      `${environment.apiUrl}/customers/${customerId}/job-places/set-default`,
      payload
    ).subscribe(res => this.defaultJobPlaceResponse.set(res));
  }
}